// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"679":"3c9fc271","701":"e9d85422","837":"36bfaddb"}[chunkId] + ".chunk.js";
};